import * as types from './index';

export const updateProfileAction = (admin) => {
  return {
    type: types.UPDATE_PROFILE,
    admin
  }
};

export const saveSecondaryDistrictsAction = (payload) => {
  return {
    type: types.SAVE_SECONDARY_DISTRICTS,
    payload
  }
};

export const changePwdAction = (admin) => {
  return {
    type: types.CHANGE_PASSWORD,
    admin
  }
};

export const resetPwdAction = (admin) => {
  return {
    type: types.RESET_PASSWORD,
    admin
  }
};

export const forgotPwdAction = (admin) => {
  return {
    type: types.FORGOT_PASSWORD,
    admin
  }
};

export const fetchAllAdminAction = (payload) => {
  return {
    type: types.FETCH_ALL_ADMIN,
    payload
  }
};

export const deregisterAdminAction = (payload) => {
  return {
    type: types.DEREGISTER_ADMIN,
    payload
  }
};